<router-outlet></router-outlet>
<ngx-toasta [position]="'top-center'"></ngx-toasta>